import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { Template } from "devextreme-react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import {
  AssetSubStatus,
  DefaultDateFormat,
  IconWithTooltip,
} from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { useNavigate } from "react-router-dom";
import "./../../../App.css";
import { useSelector } from "react-redux";
import moment from "moment";
import { Loader } from "../../Shared/PageLoader";

export default function AssetScrapRequestComponent(props) {
  const navigate = useNavigate();
  const [assetScrapRequestDataSourceLst, setAssetScrapRequestDataSourceLst] =
    useState([]);
  const refDataGrid = useRef(null);
  const user = useSelector((state) => state.user.data);
  const [state, setState] = useState({
    isCompleteLoading: false,
    loadingMessage: "",
  });

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Scrap Request`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      setTimeout(async () => {
        await getAssetScrapRequestLst(0, user?.userId);
      }, 0);
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetScrapRequestLst = async (assetScrapId, userId) => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await assetService.getAssetScrap(assetScrapId, userId);
      setAssetScrapRequestDataSourceLst(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              ref={refDataGrid}
              keyExpr="id"
              dataSource={assetScrapRequestDataSourceLst}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              columnAutoWidth={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  {
                    location: "before",
                    template: "toolbarAddTemplate",
                  },
                  {
                    location: "before",
                    template: "toolbarRefreshTemplate",
                  }
                );
              }}
            >
              <Column
                dataField="id"
                width={
                  assetScrapRequestDataSourceLst?.filter(
                    (f) =>
                      f.statusId ===
                      Number(AssetSubStatus.AssetScrapInDraftMode)
                  ).length > 0
                    ? 55
                    : 25
                }
                caption=""
                allowExporting={false}
                allowFiltering={false}
                allowSearch={false}
                allowSorting={false}
                cellRender={(cellData) => {
                  const idPrefix = `icon-${cellData?.data?.id}`;
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        {props?.featurePermission?.canView && (
                          <>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-view`}
                                className="iconify-size mr-1"
                                title="View asset scrap request"
                                tooltip="View asset scrap request"
                                icon="solar:document-text-outline"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  navigate("/ViewAssetScrapRequest", {
                                    state: {
                                      stateData: cellData.data,
                                      requestId: cellData.data?.id,
                                      isReport: false,
                                    },
                                  })
                                }
                              />
                            </span>
                          </>
                        )}

                        {props?.featurePermission?.canEdit &&
                          cellData?.data?.statusId ===
                            Number(AssetSubStatus.AssetScrapInDraftMode) && (
                            <>
                              <span>
                                <IconWithTooltip
                                  id={`${idPrefix}-edit`}
                                  className="iconify-size mr-1"
                                  title="Edit asset scrap request"
                                  tooltip="Edit asset scrap request"
                                  icon="solar:pen-line-duotone"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    navigate("/SaveAssetScrapRequest", {
                                      state: { stateData: cellData.data },
                                    })
                                  }
                                />
                              </span>
                            </>
                          )}
                      </div>
                    </>
                  );
                }}
              />
              <Column
                dataField="assetScrapRequestNo"
                caption="Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="statusName"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(e) => {
                  let color = "#28A745";
                  if (e.data?.statusId === AssetSubStatus.AssetScrapInDraftMode)
                    color = "#ee0a0aff";
                  else if (
                    e.data?.statusId === AssetSubStatus.AssetScrapBackToDraft
                  )
                    color = "#ee0a0aff";
                  else if (
                    e.data?.statusId === AssetSubStatus.AssetScrapApproved
                  )
                    color = "#4CAF50";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetScrapSentForApproval
                  )
                    color = "#FF9800";

                  return (
                    <div>
                      <span style={{ color }}>{e.data?.statusName}</span>
                      <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {e.data?.currentUserId > 0
                          ? e.data?.currentUserName
                          : e.data?.fromUserName}
                      </div>
                    </div>
                  );
                }}
              />
              <Column
                dataField="requestedDate"
                caption="Request Date"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                dataType="date"
                format={DefaultDateFormat.GridDayMonthYearDateFormat}
              />
              <Column
                dataField="fromUserName"
                caption="From"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.fromUserName ?? ""}</span>
                      {data?.data?.fromDepartmentName && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.fromDepartmentName ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="toUserName"
                caption="To"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.toUserName ?? ""}</span>
                      {data?.data?.toDepartmentName && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.toDepartmentName ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="projectName"
                caption="Project"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.projectName ?? ""}</span>
                      {data?.data?.locationName && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.locationName ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              {/* <Column
                dataField="subject"
                caption="Subject"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              <Column
                dataField="noOfAssets"
                caption="No Of Assets"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                alignment={"center"}
              />
              {/* <Column
                dataField="note"
                caption="Note"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              /> */}
              <Column
                dataField="createdDate"
                caption="Created On"
                allowSearch={true}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.createdDate) {
                    return (
                      <>
                        <span>
                          {moment(data?.data?.createdDate).format(
                            "DD/MM/YYYY"
                          ) +
                            " " +
                            moment(data?.data?.createdDate).format("LT") ?? ""}
                        </span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.createdByName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="updatedByName"
                caption="Last Updated"
                allowSearch={true}
                allowFiltering={false}
                cellRender={(data) => {
                  if (data?.data?.updatedByName) {
                    return (
                      <>
                        <span>{data?.data?.updatedByName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toDepartmentName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Template
                name="toolbarAddTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Add"
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                          navigate("/SaveAssetScrapRequest");
                        }}
                      >
                        <i className="fas fa-plus"></i>
                        &nbsp;&nbsp;Add
                      </button>
                    </>
                  );
                }}
              />
              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            await getAssetScrapRequestLst(0);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <i className="fas fa-sync-alt"></i>
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />
              <Export enabled={true} fileName="Asset Scrap Request" />
            </DataGrid>
          </div>
        </div>
      </div>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
